export const getPaymentLinkStatus = async (sessionId, signal) => {
    const response = await fetch(`/api/payment-link-status.php?session_id=${encodeURIComponent(sessionId)}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        signal
    });
    if (!response.ok)
        throw new Error(`Payment Link status failed (${response.status})`);
    return (await response.json());
};
